import React, { Component } from 'react'
import PropType from 'prop-types'
import config from 'config'
import CtaButton from 'components/cta-button'
import Radio from 'components/radio'
import { Text } from '@cred/react-text'
import { fireGtmEvent } from 'utils/gtm'
import { reduxForm } from 'redux-form'
import { compose } from 'redux'
import PoweredBy from 'components/powered-by'
import styles from './styles.scss'

class MortgageCombinedForm extends Component {
  static propTypes = {
    widgetContext: PropType.object.isRequired,
    ctaText: PropType.string.isRequired,
    queryString: PropType.string.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      href: '',
      disabled: true,
      hasOption: true,
      mortgageOption: '',
    }
  }

  render() {
    const { ctaText } = this.props,
      { href, disabled, hasOption } = this.state

    return (
      <>
        <div className={`mortgage-combined ${styles.selection}`}>
          <Text type="body-alt" className={`${styles.title} mb-16`}>I’m looking to...</Text>
          <form>
            <Radio name="mortgageOption" onChange={this.onChange} value="mortgage" label="Purchase a home" />
            <Radio name="mortgageOption" onChange={this.onChange} value="mortgage-refinance" label="Refinance my mortgage" />
          </form>
          { !hasOption && <Text type="body-alt" className={`${styles.error} mb-8`}>Select an option above.</Text> }
        </div>
        <section className={styles.submit}>
          <CtaButton
            href={href}
            onClick={this.onClick}
            blank
            fullWidth
            disabled={disabled}
          >
            {ctaText}
          </CtaButton>
          <PoweredBy className="mt-8" />
          <div className={styles.cred}>Credible Operations, Inc. NMLS # 1681276</div>
        </section>
      </>
    )
  }

  onChange = (evt) => {
    const { value } = evt.target,
      { queryString, widgetContext } = this.props

    this.setState({
      disabled: false,
      hasOption: true,
      mortgageOption: value,
      href: `${config.credibleRoot}/${value}?${queryString}`,
    })

    fireGtmEvent('fieldChange', { ...widgetContext, mortgageOption: value })
  }

  onClick = () => {
    const { widgetContext } = this.props,
      { mortgageOption } = this.state

    if (!mortgageOption) {
      this.setState({
        hasOption: false,
      })
    } else {
      this.setState({
        hasOption: true,
      })
    }

    fireGtmEvent('ctaClick', { ...widgetContext, mortgageOption })
  }
}

export { MortgageCombinedForm }

export default compose(
  reduxForm({ form: 'mortgage-combined-form' }),
)(MortgageCombinedForm)
